import React, { Component } from 'react';
import Formulario from './DevolucionCajasForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class DevolucionCajas extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo,leerPeriodoD, 
        vaciar, numeroDevolucion } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        leerPeriodoD(periodo[5], periodo[7]);
        getModulo(periodo[5], periodo[4]);
        vaciar();
        numeroDevolucion();
        localStorage.removeItem('id_detalle_devolucion');
    }
    
    render(){
        const { loader, modulo, periodoD, listarInsumos, registroDevolucion, 
            detalleInsumo, detallePro, listarClientes, eliminarLineaInsumo,
            nuevaLineaInsumo, listarPilotos, numeroS, numeroDev,
            agregarLinea, modificarDevolucion, eliminarLinea } = this.props;
        const { crear } = this.state;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    crear = {crear}
                    modulo = {modulo}
                    periodoD = {periodoD}
                    detalleCon = {detallePro}
                    registroDevolucion = {registroDevolucion}
                    modificarDevolucion = {modificarDevolucion}
                    listarInsumos = {listarInsumos}
                    detalleInsumo = {detalleInsumo}
                    numeroS = {numeroS}
                    agregarLinea = {agregarLinea}
                    listarPilotos = {listarPilotos}
                    listarClientes = {listarClientes}
                    eliminarLinea = {eliminarLinea}
                    nuevaLineaInsumo = {nuevaLineaInsumo}
                    eliminarLineaInsumo = {eliminarLineaInsumo}
                    numeroDev = {numeroDev}
                />
            </LoadMask>
        );
    }
}

export default DevolucionCajas
